import React, { useEffect, useState } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { ListItemText } from "@material-ui/core";
import { useParams } from "react-router";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import { httpPost } from "../../../../../../../Utils/apis/apis";
import { epochToDateFormatHelper } from "../../../../../../../Utils/Helpers/dateUtils";
import selectedIcon from "./Icon.helpers";
import * as previousUploadActions from "../../../../../../../store/actions/previousUploadActions";
import * as previousUploadDeleteActions from "../../../../../../../store/actions/previousUploadDeleteActions";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import M_ActionGroup from "../../../ActionGroup/M_ActionGroup";
import { sortFiles } from "../../../../../../Factory/Molecules/Common/Renderers/Views/PreviousTemplate/previousUpload.helper";
import LoaderSkeleton from "../../../LoaderSkeleton";
import { executeJSString } from "../../../../../Pages/Common/Layouts/layout.Helper";
import { getObjectFromJSONString } from "../../../Navigations/AddEntity/M_ManageEntityForm.helper";
import { subdomain } from "../../../../../Atoms/DataDisplay/DataGrid/helper/download.helper";

const useStyles = makeStyles(() => ({
  CustomCard: {
    maxHeight: "52vh",
    overflow: "scroll",
    overflowX: "hidden",
  },
  list: {
    borderBottom: "1px solid lightgrey",
    "&:hover": {
      backgroundColor: "#f9f9f9",
      cursor: "pointer",
    },
  },
  avatar: {
    margin: "auto",
    paddingLeft: "10px",
  },
  heading: {
    marginTop: "10px",
  },
  ActionGroup: {
    paddingTop: "25px",
  },
  ListFlex: {
    display: "flex",
  },
  disabled: {
    opacity: 0.5,
    pointerEvents: "none",
    cursor: "none"
  },
  noData: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "smaller",
    fontWeight: "500",
    marginTop: "10px",
  }
}));

const PreviousUploads = (props) => {
  const classes = useStyles();
  const { content = {}, previousUpload, getPreviousUpload, delfile, getPreviousUploadDelete, currentPage = {} } = props;
  const show_noContent_message = content.securityOnUpload && !currentPage.pageConfig?.pageSecurity?.Full && !currentPage.pageConfig?.pageSecurity?.Update;
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  let { templateId, crmId, pageUrl } = useParams();
  const [disabledItems, setDisabledItems] = useState([]);

  useEffect(() => {
    if (previousUpload.data) {
      let sortedElements = sortFiles({ data: previousUpload.data, sorting: content.sorting });
      setReports(sortedElements);
      setIsLoading(false);
    } else {
      setIsLoading(true)
    }
    if (previousUpload?.data && content.securityOnDownload && !currentPage.pageConfig?.pageSecurity?.Full && !currentPage.pageConfig?.pageSecurity?.Update) {
      setDisabledItems(previousUpload.data.map(() => true))
    }
  }, [JSON.stringify(previousUpload)]);

  useEffect(() => {
    previousUpload.data = undefined;
    getPreviousUpload({
      crmId: crmId,
      pageUrl: content.fileName ?? pageUrl,
      container: content.containerType,
      directory: content.directory,
    });
    setReports([]);
  }, [templateId]);

  const handleDataChange = () => {
    setTimeout(() => {
      getPreviousUpload({
        crmId: crmId,
        pageUrl: content.fileName ?? pageUrl,
        container: content.containerType,
        directory: content.directory,
      });
      delfile();
    }, 1000);
  };

  const handelDelete = async (e) => {
    const docName = e;
    const fileOp = "delete";
    await getPreviousUploadDelete({
      documentName: docName,
      fileOperation: fileOp,
      containerType: content.containerType,
    });
  };

  const handleClick = async (e, index) => {
    if (content.securityOnDownload && !currentPage.pageConfig?.pageSecurity?.Full && !currentPage.pageConfig?.pageSecurity?.Update) {
      return;
    }
    // Disable the specific item
    setDisabledItems((prevDisabledItems) => {
      const updatedDisabledItems = [...prevDisabledItems];
      updatedDisabledItems[index] = true;
      return updatedDisabledItems;
    });
    //TODO - refactor it. Use saga for async behavior.
    const documentName = e.file;
    const url = `${process.env.DOCUMENT_HELPER}`;
    let header = {
      filename: documentName,
      type: content.containerType || "generic",
      "file-operation": "download",
      "process-file": "yes",
      "x-functions-key": process.env.DOCUMENT_HELPER_KEY,
      subdomain: subdomain,
    };
    httpPost(
      url,
      {
        method: "GET",
      },
      { responseType: "blob", headers: header }
    ).then((response) => {
      const url1 = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url1;
      link.setAttribute("download", e.fileDisplayName);
      document.body.appendChild(link);
      link.click();
      //Enabling specific item
      setDisabledItems((prevDisabledItems) => {
        const updatedDisabledItems = [...prevDisabledItems];
        updatedDisabledItems[index] = false;
        return updatedDisabledItems;
      });
    });
  };
  var documentName = _.get(props, "content.name");

  return (
    <>
      {documentName ? (
        <div className={classes.heading}>
          <h5>{documentName} </h5>
        </div>
      ) : (
        ""
      )}

      <div className={classes.CustomCard}>
        {/* TODO - correct logic as per new implementation (saga) */}
        {isLoading ? (
          <LoaderSkeleton />
        ) : reports && reports.length > 0 ? (
          reports.map((item, index) => (
            <ListItem key={index} className={classes.list}>
              <Grid container spacing={2}>
                <Grid xs={11}>
                  <List
                    button
                    onClick={() => handleClick(item, index)}
                    className={`${classes.ListFlex} ${disabledItems[index] ? classes.disabled : ""
                      }`}
                  >
                    <ListItemAvatar className={classes.avatar}>
                      <Avatar
                        src={selectedIcon(item.fileDisplayName)}
                        variant="square"
                      />
                    </ListItemAvatar>

                    <ListItem alignItems="flex-start">
                      <ListItemText
                        primary={item.fileDisplayName}
                        secondary={
                          "Uploaded on " +
                          epochToDateFormatHelper(
                            `${item.modifiedTime || item.creationTime}${content.dateTimeZone === "UTC" ? "" : "Z"}`,
                            getObjectFromJSONString(
                              props,
                              ".content.dateFormat"
                            ) || "DD-MM-YYYY"
                          )
                        }
                      />
                    </ListItem>
                  </List>
                </Grid>
                {currentPage.pageConfig?.pageSecurity?.Full &&
                  executeJSString(
                    getObjectFromJSONString(props, ".content.readOnlyTemplate"),
                    getObjectFromJSONString(props, ".currentPage.data")
                  ) != true ? (
                  <Grid xs={1} className={classes.ActionGroup}>
                    <div>
                      <M_ActionGroup
                        delete={content.delete}
                        onDelete={() => handelDelete(item.file)}
                        handleDataChange={() => handleDataChange()}
                        modify={true}
                      />
                    </div>
                  </Grid>
                ) : (
                  ""
                )}
              </Grid>
            </ListItem>
          ))
        ) : (
          show_noContent_message &&
          <div className={classes.noData}>
            <p>WE ARE SORRY, NO CONTENT FOUND!</p>
          </div>
        )}
      </div>
    </>
  );
};
PreviousUploads.propTypes = {
  previousUpload: PropTypes.any,
  getPreviousUpload: PropTypes.any,
  getPreviousUploadDelete: PropTypes.any,
  delfile: PropTypes.func,
  currentPage: PropTypes.any,
  content: PropTypes.any,
};

function mapStateToProps(state) {
  return {
    previousUpload: state.previousUpload,
    previousUploadDelete: state.previousUploadDelete,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    Object.assign({}, previousUploadActions, previousUploadDeleteActions),
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(PreviousUploads);
